module.exports = __webpack_public_path__ + "img/music-file.46f68c3e.svg";